"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroblocksApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class MicroblocksApi extends runtime.BaseAPI {
    /**
     * Get a specific microblock by hash
     * Get microblock
     */
    async getMicroblockByHashRaw(requestParameters, initOverrides) {
        if (requestParameters.hash === null || requestParameters.hash === undefined) {
            throw new runtime.RequiredError('hash', 'Required parameter requestParameters.hash was null or undefined when calling getMicroblockByHash.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/microblock/{hash}`.replace(`{${"hash"}}`, encodeURIComponent(String(requestParameters.hash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MicroblockFromJSON(jsonValue));
    }
    /**
     * Get a specific microblock by hash
     * Get microblock
     */
    async getMicroblockByHash(requestParameters, initOverrides) {
        const response = await this.getMicroblockByHashRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get recent microblocks
     */
    async getMicroblockListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/microblock`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.MicroblockListResponseFromJSON(jsonValue));
    }
    /**
     * Get recent microblocks
     */
    async getMicroblockList(requestParameters, initOverrides) {
        const response = await this.getMicroblockListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * This contains transactions that have been streamed in microblocks but not yet accepted or rejected in an anchor block
     * Get the list of current transactions that belong to unanchored microblocks
     */
    async getUnanchoredTxsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/microblock/unanchored/txs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.UnanchoredTransactionListResponseFromJSON(jsonValue));
    }
    /**
     * This contains transactions that have been streamed in microblocks but not yet accepted or rejected in an anchor block
     * Get the list of current transactions that belong to unanchored microblocks
     */
    async getUnanchoredTxs(initOverrides) {
        const response = await this.getUnanchoredTxsRaw(initOverrides);
        return await response.value();
    }
}
exports.MicroblocksApi = MicroblocksApi;
//# sourceMappingURL=MicroblocksApi.js.map